import { Cancel, CheckCircle, VolumeUp } from '@mui/icons-material';
import React, { useState, useEffect, useRef } from "react";
import { Howl } from 'howler';
import './matchMaking.css';
import MatchAudioPng from "utils/assets/images/Match-Audio.png";
import MessageRenderer from 'components/MessageRenderer';
import { getMatchMediaData } from 'utils/methods/assignmentTranscripts';

const MatchTranscriptText = ({ mediaData }) => {
    if (!mediaData?.transcript) return null;
    return (
        <div style={{ marginTop: 6, fontSize: 12, lineHeight: 1.4, maxWidth: 200 }}>
            <MessageRenderer data={mediaData.transcript} />
        </div>
    );
};

const MatchItem = ({ id, image, MatchType , text, item, activeAudio, setActiveAudio, transcripts = {} }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const howlRef = useRef(null);

    useEffect(() => {
        const audioUrl = MatchType === 'ImageAndAudio' ? item?.match_audio : item?.match_item;
        
        if ((MatchType === 'Audio' || MatchType === 'ImageAndAudio') && audioUrl) {
            howlRef.current = new Howl({
                src: [audioUrl],
                html5: true,
                onplay: () => setIsPlaying(true),
                onend: () => {
                    setIsPlaying(false);
                    setActiveAudio(null);
                },
                onpause: () => setIsPlaying(false),
                onstop: () => {
                    setIsPlaying(false);
                    setActiveAudio(null);
                }
            });
        }

        return () => {
            if (howlRef.current) {
                howlRef.current.unload();
            }
        };
    }, [MatchType, item]);

    const handleAudioClick = () => {
        if (!howlRef.current) return;

        if (isPlaying) {
            howlRef.current.pause();
            setIsPlaying(false);
            setActiveAudio(null);
        } else {
            if (activeAudio && activeAudio !== howlRef.current) {
                activeAudio.stop();
            }
            setActiveAudio(howlRef.current);
            howlRef.current.play();
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                marginTop: '20px',
                flexWrap: 'wrap',
                opacity: 1,
                marginRight: '20px',
                alignItems: MatchType === 'Text' ? 'center' : 'flex-start'
            }}>
            <div>
                <div
                    style={{
                        borderRadius: "0px !important",
                        minWidth: "20px",
                        marginRight: '5px',
                        maxHeight: '20px',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    className={`matchItemIndex`}
                >
                    {String.fromCharCode(65 + id)}
                </div>
                {MatchType === 'ImageAndAudio' && (
                    <div
                        style={{
                            marginTop: '20px',
                            cursor: 'pointer'
                        }}
                        onClick={handleAudioClick}
                    >
                        <img
                            src={MatchAudioPng}
                            alt={'audio'}
                            loading="lazy"
                            style={{
                                width: "23px",
                                height: "23px",
                                objectFit: "cover",
                                borderRadius: "50%"
                            }}
                        />
                    </div>
                )}
            </div>
           {MatchType === 'Text' ? (
               <div><span dangerouslySetInnerHTML={{ __html: text || '' }} /></div>
           ) : MatchType === 'Audio' ? (
            <div>
               <div 
                   onClick={handleAudioClick}
               >
                   <img
                       src={MatchAudioPng}
                       alt={`Match ${id}`}
                       draggable={false}
                       loading="lazy"
                       style={{
                           width: "100px",
                           height: "100px",
                           objectFit: "cover",
                       }}
                   />
               </div>
               <MatchTranscriptText mediaData={getMatchMediaData(item, 'right', 'Text', MatchType, transcripts)} />
               </div>
           ) : (
            <img
                src={image}
                alt={`Match ${id}`}
                draggable={false}
                loading="lazy"
                style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    // boxShadow: isDragging ? "0px 0px 5px rgba(0, 0, 0, 0.5)" : "none",
                }}
            />)}
        </div>
    );
};

const DropTarget = ({ selectedItem, values, status, QuestionType, matchType, activeAudio, setActiveAudio, neutral = false, transcripts = {} }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const howlRef = useRef(null);

    useEffect(() => {
        const audioUrl = QuestionType === 'Audio' ? values?.questionAudio : 
                        QuestionType === 'ImageAndAudio' ? values?.questionAudio : null;
        
        if ((QuestionType === 'Audio' || QuestionType === 'ImageAndAudio') && audioUrl) {
            howlRef.current = new Howl({
                src: [audioUrl],
                html5: true,
                onplay: () => setIsPlaying(true),
                onend: () => {
                    setIsPlaying(false);
                    setActiveAudio(null);
                },
                onpause: () => setIsPlaying(false),
                onstop: () => {
                    setIsPlaying(false);
                    setActiveAudio(null);
                }
            });
        }

        return () => {
            if (howlRef.current) {
                howlRef.current.unload();
            }
        };
    }, [QuestionType, values]);

    const handleAudioClick = () => {
        if (!howlRef.current) return;

        if (isPlaying) {
            howlRef.current.pause();
            setIsPlaying(false);
            setActiveAudio(null);
        } else {
            if (activeAudio && activeAudio !== howlRef.current) {
                activeAudio.stop();
            }
            setActiveAudio(howlRef.current);
            howlRef.current.play();
        }
    };

    return (
        <div
            style={{
                borderRadius: "0px !important",
                minWidth: "100px",
                height: "36px",
                marginRight: '10px',
                marginBottom: '15px',
                color: 'white',
                backgroundColor: "#010e4c",
                position: 'relative',
            }}
            className={`222 matchItem matchItemTxtInr`}
        >
            {!neutral && (
            <div style={{
                position: 'absolute',
                left: -9,
                top: -9,
                backgroundColor: 'white',
                height: '16px',
                width: '16px',
                borderRadius: '50%'
            }}>
                {status ? <CheckCircle style={{ color: "green", fontSize: '20px' }} /> : <Cancel color="secondary" style={{ fontSize: '20px' }} />}
            </div>
            )}
            <div>
                {!neutral && selectedItem !== undefined && (
                    <div
                        style={{
                            borderRadius: "0px !important",
                            minWidth: "18px",
                            marginRight: '5px',
                            maxHeight: '20px',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        className={`matchItemIndex`}
                    >
                        {String.fromCharCode(65 + selectedItem)}
                    </div>
                )}
            </div>
            <div>
                {QuestionType === 'Audio' ? (
                    <div>
                    <div 
                        onClick={handleAudioClick}
                        style={{
                            cursor: 'pointer',
                            position: 'relative',
                            display: 'inline-block',
                            borderRadius: '8px',
                            padding: '2px'
                        }}
                    >
                        <img 
                            src={MatchAudioPng} 
                            style={{width: '100px', height: '100px', objectFit: 'cover'}} 
                            alt="audio" 
                        />
                    </div>
                    <MatchTranscriptText mediaData={getMatchMediaData(values, 'left', QuestionType, matchType, transcripts)} />
                    </div>
                ) : QuestionType === 'Image' ? (
                    <img src={values?.questionImage} style={{width: '100px', height: '100px', objectFit: 'cover'}} alt="image" />
                ) : QuestionType === 'ImageAndAudio' ? (
                    <div>
                    <div style={{ position: 'relative' }}>
                        <img 
                            src={values?.questionImage} 
                            style={{width: '100px', height: '100px', objectFit: 'cover'}} 
                            alt="image" 
                        />
                        <div
                            onClick={handleAudioClick}
                        >
                            <VolumeUp style={{ color: '#fff', fontSize: '20px' }} />
                        </div>
                    </div>
                    <MatchTranscriptText mediaData={getMatchMediaData(values, 'left', QuestionType, matchType, transcripts)} />
                    </div>
                ) : (
                    <div><span dangerouslySetInnerHTML={{ __html: values?.item || '' }} /></div>
                )}
            </div>
        </div>
    );
};

const MatchMakingReview = ({ question, answer, neutral = false, transcripts = {} }) => {
    const matchQuestion = question?.options || [];
    const MatchType = question?.matchType || 'Image';
    const QuestionType = question?.questionType || 'Text';
    const [activeAudio, setActiveAudio] = useState(null);

    return (
        <div style={{ marginTop: '30px' }}>
            <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "20px" }}>
                {matchQuestion.map((option, index) => {
                    const matchData = answer.match_data.find((data) => data.item === index);
                    const status = matchData?.is_correct;
                    return (
                        <DropTarget
                            key={`drop-${index}`}
                            selectedItem={matchData?.match_item}
                            values={option}
                            status={status}
                            QuestionType={QuestionType}
                            matchType={MatchType}
                            activeAudio={activeAudio}
                            setActiveAudio={setActiveAudio}
                            neutral={neutral}
                            transcripts={transcripts}
                        />
                    );
                })}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", marginTop: "20px" }}>
                {matchQuestion.map((item, index) => (
                    <MatchItem
                        key={`match-${index}`}
                        id={index}
                        image={item?.match_item}
                        text={item?.match_text}
                        MatchType={MatchType}
                        item={item}
                        activeAudio={activeAudio}
                        setActiveAudio={setActiveAudio}
                        transcripts={transcripts}
                    />
                ))}
            </div>
        </div>
    );
};

export default MatchMakingReview;